import { render, staticRenderFns } from "./AjusteStock.vue?vue&type=template&id=08000425&scoped=true"
import script from "./AjusteStock.vue?vue&type=script&lang=js"
export * from "./AjusteStock.vue?vue&type=script&lang=js"
import style0 from "./AjusteStock.vue?vue&type=style&index=0&id=08000425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08000425",
  null
  
)

export default component.exports